if (process.env.GTM_ID) {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    const f = document.getElementsByTagName('script')[0];
    const j = document.createElement('script');
    j.async = true;
    j.src = 'https://www.funding.com.au/metrics/?id=' + process.env.GTM_ID;
    f.parentNode.insertBefore(j, f);
}